// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2t8XS","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2S0UP","obliqueLine":"membershipbadge_obliqueLine__1MBvn"};